export default __webpack_public_path__ + "static/media/task_assessment_icon.c735eb25.svg";